<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">IP访问记录</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>用户IP状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 8em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>封号类型：</label>
          <el-select v-model="forbiddenState" placeholder="Select" style="width: 8em" >
            <el-option v-for="item in forbiddenStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>设备冻结：</label>
          <el-select v-model="idfaBanState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in idfaBanStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" v-loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div style="display: flex; align-items: center;">
<!--          <ElButtons icon="Comment" @click="sendSysMsg">发送通知</ElButtons>-->
<!--          <el-button type="danger" @click="batchReject">批量不通过</el-button>-->
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            border
            @cell-click="toggleSelection"
            v-loading="listLoading"
            @selection-change="selsChange"
            @header-click="selsAll"
        >
<!--          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
          <el-table-column property="createTime" label="访问时间" v-if="checkColList.indexOf('访问时间') > -1"/>
          <el-table-column label="头像" v-if="checkColList.indexOf('头像') > -1" min-width="105">
            <template #default="scope">
                <div v-if="scope.row.headImg">
                    <HeadImg :images="scope.row.headImg" />
                </div>
            </template>
          </el-table-column>
          <el-table-column label="用户信息" v-if="checkColList.indexOf('用户信息') > -1" min-width="200">
            <template #default="scope">
              <UserInfoList :row="scope.row" showList="name,phone,uid,city"/>
            </template>
          </el-table-column>
          <el-table-column property="ip" label="IP" v-if="checkColList.indexOf('IP') > -1"/>
          <el-table-column prop="location" label="定位信息" v-if="checkColList.indexOf('定位信息') > -1" min-width="90"></el-table-column>
          <el-table-column prop="" label="现居城市" v-if="checkColList.indexOf('现居城市') > -1" min-width="90">
            <template #default="scope">
                <p>{{ scope.row.province }} {{ scope.row.city }} </p>
            </template>
          </el-table-column>
          <el-table-column label="IP变更记录" v-if="checkColList.indexOf('IP变更记录') > -1" min-width="100" class-name="cursor">
            <template #default="scope">
                <span style="color: #3a8ee6">{{ scope.row.abnormalNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="APP信息" v-if="checkColList.indexOf('APP信息') > -1" width="160">
            <template #default="scope">
                <p>平台：{{scope.row.platformType==1?'Android':scope.row.platformType==2?'IOS':scope.row.platformType==3?'web':scope.row.platformType==4?'鸿蒙':''}}</p>
                <p>app渠道：{{scope.row.channel}}</p>
                <p>app自建版本号：{{scope.row.versionId}}</p>
            </template>
          </el-table-column>
          <el-table-column label="身份认证" v-if="checkColList.indexOf('身份认证') > -1" min-width="130">
            <template #default="scope">
                <div v-if="scope.row.identityAuth">
                    <p>{{scope.row.identityAuth.identityState == 0 ? '未提交' : scope.row.identityAuth.identityState == 1 ? '待审核' : scope.row.identityAuth.identityState == 2 ? '审核通过' : (scope.row.identityAuth.identityState == 3 || scope.row.identityAuth.identityState == 4 || scope.row.identityAuth.identityState == 5) ? '审核不通过' : ''}}</p>
                    <p v-if="scope.row.identityAuth.identityState == 2">
                        <get-plain title="" :code="scope.row.identityAuth.identityCode" :uid="scope.row.uid" :type="10" :subType="1"/>
                    </p>
                </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="芝麻认证" min-width="120">
            <template #default="scope">
                <div v-if="scope.row.identityAuth">
                    <p>{{scope.row.identityAuth.zhimaState == 0 ? '审核不通过' : scope.row.identityAuth.zhimaState == 1 ? '审核通过' : ''}}</p>
                    <p v-if="scope.row.identityAuth.zhimaState == 1">
                        <get-plain title="" :code="scope.row.identityAuth.zhimaCertCode" :uid="scope.row.uid" :type="10" :subType="2"/>
                    </p>
                </div>
            </template>
          </el-table-column>
          <el-table-column prop="" label="百度认证" min-width="120">
            <template #default="scope">
                <div v-if="scope.row.identityAuth">
                    <p>{{scope.row.identityAuth.baiduState == 0 ? '审核不通过' : scope.row.identityAuth.baiduState == 1 ? '审核通过' : ''}}</p>
                    <p v-if="scope.row.identityAuth.baiduState == 1">
                        <get-plain title="" :code="scope.row.identityAuth.baiduCertCode" :uid="scope.row.uid" :type="10" :subType="3"/>
                    </p>
                </div>
            </template>
          </el-table-column>
          <el-table-column label="用户IP状态" v-if="checkColList.indexOf('用户IP状态') > -1" width="100">
            <template #default="scope">
              <span>{{scope.row.state == 0 ? '正常' : scope.row.state == 1 ? '异常' : scope.row.state == 2 ? '异常变为正常' : ''}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" v-if="checkColList.indexOf('操作') > -1" width="100">
            <template #default="scope">
<!--                <el-space direction="vertical" alignment="left" :size="6">-->
<!--                    <el-button v-if="!scope.row.isForbidden" type="primary" size="small" @click="updateUserForbidden(scope.$index, scope.row, 1)" v-loading="scope.row['forbiddenLoading']">封号</el-button>-->
<!--                    <el-button v-if="scope.row.isForbidden" type="success" size="small" @click="updateUserForbidden(scope.$index, scope.row, 2)" v-loading="scope.row['forbiddenLoading']">解除封号</el-button>-->
<!--                    <el-button v-if="!scope.row.isIdfaBan" type="primary" size="small" @click="updateUserIdfaBan(scope.$index, scope.row, 0)" v-loading="scope.row['isIdfaBanLoading']">冻结设备</el-button>-->
<!--                    <el-button v-if="scope.row.isIdfaBan" type="success" size="small" @click="updateUserIdfaBan(scope.$index, scope.row, 1)" v-loading="scope.row['isIdfaBanLoading']">解除冻结</el-button>-->
<!--                    <AppointAuth :row="scope.row" />-->
<!--                </el-space>-->
              <ActionButton :row="scope.row" showList="forbidden,idfa,point"/>
            </template>
          </el-table-column>
          <el-table-column label="用户日志" v-if="checkColList.indexOf('用户日志') > -1" class-name="cursor" width="200">
            <template #default="scope">
              <UserLog :user-log-list="scope.row.userLogList" />
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import {
    getIpVisitPageList, updateUserForbidden, updateUserIdfaBan,
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from '../../assets/js/dialog'
import SendSystemMessage from "@/components/SendSystemMessage";
import UserLogDialog from '../../components/UserLog/UserLogDialog'
import ImgViewer from '../../assets/js/imageViewer'
import UserLog from "@/components/UserLog/UserLog";
import GetPlain from "@/components/resume/GetPlain";
import ipCityAbnormalDialog from "../../components/resume/ipCityAbnormalDialog";
import AppointAuth from "@/components/resume/AppointAuth";
import ForbiddenDialog from "../../components/resume/ForbiddenDialog";
import ActionButton from "@/components/resume/ActionButton";


export default {
  name: "IpVisit",
  components: { DatePickerRange, SearchComponents, UserLog, GetPlain, AppointAuth, ActionButton },
  data() {
    return {

      //用户IP状态
      stateArray: [
        {label: '不限', value: -1},
        {label: '正常', value: 0},
        {label: '异常', value: 1},
        {label: '异常变为正常', value: 2},
      ],
      state: -1,

      // 封号类型
      forbiddenStateArray: [
        {label: '不限', value: -1},
        {label: '未封号', value: 0},
        {label: '已封号', value: 1},
      ],
      forbiddenState: -1,

      // 设备冻结
      idfaBanStateArray: [
        {label: '不限', value: -1},
        {label: '已冻结', value: 0},
        {label: '未冻结', value: 1},
      ],
      idfaBanState: -1,

      passLoading: false,


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
          {label: '手机号码', value: 1},
          {label: '昵称', value: 2},
          {label: 'UID', value: 3},
          {label: 'IP', value: 4},
          {label: '渠道', value: 5},
      ],
      searchType: 2,
      searchValue: '',

      //刷新组
      colList: ['访问时间','头像', '用户信息', 'IP', '定位信息', '现居城市', 'IP变更记录', 'APP信息', '身份认证', '芝麻认证','百度认证','用户IP状态', '操作', '用户日志'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      //选中id
      idArray: [],
      userIdArray: [],
      //选中性别
      userSexArray: [],

    }
  },
  methods: {

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.state = -1;
      this.forbiddenState = -1;
      this.idfaBanState = -1;
      this.startTime = '';
      this.endTime = '';
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.userId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.userId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['forbiddenState'] = this.forbiddenState;
      param['idfaBanState'] = this.idfaBanState;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getIpVisitPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },


    //图片预览

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList
      })
    },

    toggleSelection(row, column, cell, event) {

      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }

      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

        //
        if(column.label == 'IP变更记录') {
            Dialog.open({
                title: '用户【' + row.nickName + '】的IP变更记录',
                component: ipCityAbnormalDialog,
                data: {
                    id: row.userId,
                    width: '600px',
                    ipState: -1,
                },
                confirm: (result) => {

                }
            })
        }




    },


    //发送系统消息
    sendSysMsg() {
      if(this.idArray.length == 0) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请至少选择一条记录进行操作',
          type: 'warning'
        })
        return false
      }
      Dialog.open({
        title: '发送小助手通知',
        component: SendSystemMessage,
        data: {
          userIdArray: this.idArray,
          width: '600px'
        },
        confirm: () => {

        }
      })
    },

      //更新封号
      updateUserForbidden(idx, row, state) {
          if(state == 1) {
              Dialog.open({
                  title: '确定对用户【' + row.nickName + '】封号？',
                  component: ForbiddenDialog,
                  data: {
                      userId: row.userId,
                      width: '500px'
                  },
                  confirm: () => {
                      this.getPage()
                  }
              })
          } else if(state == 2) {
              this.$confirm('确定【取消封号】用户' +'【' + row.nickName + '】?').then(()=>{
                  this.pageDataList[idx]['forbiddenLoading'] = true
                  let param = {}
                  param['id'] = row.userId
                  param['state'] = state
                  param['type'] = 99
                  param['idfaBanState'] = 0
                  postFormData(updateUserForbidden, param).then((data)=>{
                      let {code, msg} = data
                      if(code == 200) {
                          this.$message({
                              showClose: true,
                              duration: 1000,
                              message: msg,
                              type: 'success'
                          })
                          this.pageDataList[idx]['isForbidden'] = false
                      }else {
                          this.$message({
                              showClose: true,
                              duration: 1000,
                              message: msg,
                              type: 'warning'
                          })
                      }
                      this.pageDataList[idx]['forbiddenLoading'] = false
                  }).catch(()=>{
                      this.pageDataList[idx]['forbiddenLoading'] = false
                  })
              })
          }
      },

      //冻结设备
      updateUserIdfaBan(idx, row, state) {
          this.$confirm('确定' + (state == 0?'冻结':'解冻') + '用户' +'【' + row.nickName + '】的设备?').then(()=>{
              this.pageDataList[idx]['isIdfaBanLoading'] = true
              let param = {}
              param['id'] = row.userId
              param['state'] = state
              postFormData(updateUserIdfaBan, param).then((data)=>{
                  let {code, msg} = data
                  if(code == 200) {
                      this.$message({
                          showClose: true,
                          duration: 1000,
                          message: msg,
                          type: 'success'
                      })
                      this.pageDataList[idx]['isIdfaBan'] = state == 0?true:false
                  }else {
                      this.$message({
                          showClose: true,
                          duration: 1000,
                          message: msg,
                          type: 'warning'
                      })
                  }
                  this.pageDataList[idx]['isIdfaBanLoading'] = false
              }).catch(()=>{
                  this.pageDataList[idx]['isIdfaBanLoading'] = false
              })
          })
      },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>
.playBtn {
  font-size: 5em;
  color: #c0c4cc;
  cursor: pointer;
}
.playBtn:hover {
  font-size: 5em;
  color: #3a8ee6;
}
</style>
